/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-05-11 16:29:10
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\edit\edit.js
 * @Description: 
 */
/*
author:wang.jiang 2016-1-16
 */
'use strict';
angular.module('editctrNewspaperEditModule', [
    'editctrNewspaperRouterModule',
    'editctrNewspaperTextModule',
    'editctrNewspaperPicModule'
]);
